import request from '@/utils/request'

/* 获取区域 */
export function areaInfoOrderList(params) {
    return request({
        url: `/api/construction/order/areaInfoOrderList`,
        method: 'post',
        data: params
    })
}

/* 获取区域 */
export function getOrderOneInfo(params) {
    return request({
        url: `/api/construction/order/wx/getOrderOneInfoById/${params.id}`,
        method: 'get',
        params
    })
}

/* 获取参数 */
export function selectDictDataUserList(params) {
    return request({
        url: `/api/construction/order/wx/selectDictDataUserList`,
        method: 'get',
        params
    })
}
/* 获取区域 */
export function getOrderOneInfoByMaintenanceNew(params) {
    return request({
        url: `/api/construction/order/wx/getOrderOneInfoByMaintenanceNew/${params.id}`,
        method: 'get',
        params
    })
}

